import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Fieldset } from 'primereact/fieldset'
import React, { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../../assets/js/styles'
import {
  Btn,
  Cnpj,
  CustomPanel,
  Loading,
  PageHeader,
  CustomDataTableHeader,
  Periodo,
  CustomMultiSelect,
  NumeroDecimal,
  CustomTabView,
  ThreeDots,
  DateTime,
  BadgeStatusEntrega,
} from '../../../../../components'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import useCargasParadasTransferencia, { MENU_ITEMS_NAMES } from './CargasParadasTransferenciaHook'
import { buildUfOptions, normalizeUf } from '../../../../../services/util/estados.service'
import { TabPanel } from 'primereact/tabview'
import ModalDetalhesPorEmpresa from '../ModalDetalhesPorEmpresa/ModalDetalhesPorEmpresa'
import ModalDisponivel from '../ModalDisponivel/ModalDisponivel'
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'

function CargasParadasTransferencia({ history, dispatch, selectedTp }) {
  const { state, localDispatch } = useCargasParadasTransferencia()
  const [globalFilter, setGlobalFilter] = useState('')

  const [selectedUfs, setSelectedUfs] = useState([])
  const [ufOptions, setUfOptions] = useState([])
  const [selectedCities, setSelectedCities] = useState([])
  const [citiesOptions, setCitiesOptions] = useState([])

  useEffect(() => {
    state.errorMessage &&
      dispatch(showMessageBox(null, state.errorMessage)) &&
      localDispatch.resetMessages()
  }, [state.errorMessage])

  useEffect(() => {
    state.successMessage &&
      dispatch(showMessageBox(state.successMessage, null)) &&
      localDispatch.resetMessages()
  }, [state.successMessage])

  useEffect(() => {
    if (!selectedTp) {
      dispatch(showMessageBox(null, 'Selecione um operador logístico'))
    } else {
      localDispatch.fetchDeliveriesToBeTransferred(selectedTp, state.periodo)
    }
  }, [selectedTp, state.periodo])

  useEffect(() => {
    const base = state.entregasOriginais || []
    const hasUf = base.some(e => !!e.uf_sigla)
    setUfOptions(hasUf ? buildUfOptions(base, 'uf_sigla') : [])
    setSelectedUfs([])
    const allCities = [...new Set(base.map(e => e.city).filter(Boolean))]
      .sort()
      .map(c => ({ label: c, value: c }))
    setCitiesOptions(allCities)
    setSelectedCities([])
  }, [state.entregasOriginais])

  useEffect(() => {
    const base = state.entregasOriginais || []
    let filtered = base
    if (selectedUfs.length) {
      filtered = filtered.filter(t => selectedUfs.includes(normalizeUf(t.uf_sigla)))
    }
    const cities = [...new Set(filtered.map(t => t.city).filter(Boolean))]
      .sort()
      .map(c => ({ label: c, value: c }))
    setCitiesOptions(cities)
    setSelectedCities([])
  }, [selectedUfs, state.entregasOriginais])

  const locationFilteredEntregas = useMemo(() => {
    let data = state.entregas || []
    if (ufOptions.length && selectedUfs.length) {
      data = data.filter(t => selectedUfs.includes(normalizeUf(t.uf_sigla)))
    }
    if (selectedCities.length) {
      data = data.filter(t => selectedCities.includes(t.city))
    }
    return data
  }, [state.entregas, ufOptions.length, selectedUfs, selectedCities])

  // Components
  return (
    <div>
      <PageHeader>
        <span>Cargas Paradas Transferência</span>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          {state.isContentLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <>
              <Fieldset legend="Filtros">
                <div className="p-grid">
                  <div className="p-col-4">
                    <Periodo
                      periodoFinal={state.periodo.pFinal}
                      periodoInicial={state.periodo.pInicial}
                      onPesquisar={localDispatch.onChangePeriodo}
                    />
                  </div>
                  <div className="p-col-3">
                    <CustomMultiSelect
                      marginTop={9}
                      optionLabel="name"
                      options={state.empresas}
                      value={state.empresaSelecionada}
                      label="Empresa :"
                      onChange={value =>
                        localDispatch.onFormDataChange('empresaSelecionada', value)
                      }
                    />
                  </div>
                  <div className="p-col-3">
                    <CustomMultiSelect
                      marginTop={9}
                      optionLabel="name"
                      options={state.tps}
                      value={state.tpSelecionado}
                      label="Destino :"
                      onChange={value => localDispatch.onFormDataChange('tpSelecionado', value)}
                    />
                  </div>
                  <div className="p-col-2" style={{ paddingTop: 32 }}>
                    <div style={{ display: 'inline-block', marginLeft: 10 }}>
                      <Btn onClick={() => {
                        localDispatch.limpar()
                        setSelectedUfs([])
                        setSelectedCities([])
                      }}>Limpar</Btn>
                    </div>
                  </div>
                </div>
              </Fieldset>
              <Fieldset
                legend="Filtro"
                toggleable
                collapsed={true}
                style={{ marginBottom: 20, marginTop: 20 }}
              >
                <div style={{ display: 'flex', gap: 16 }}>
                  {ufOptions.length > 0 && (
                    <div className="p-col-2" style={{ minWidth: 200 }}>
                      <CustomMultiSelect
                        marginTop={10}
                        label="Estados"
                        options={ufOptions}
                        value={selectedUfs}
                        onChange={setSelectedUfs}
                      />
                    </div>
                  )}
                  <div className="p-col-2" style={{ minWidth: 200 }}>
                    <CustomMultiSelect
                      marginTop={10}
                      label="Cidades"
                      options={citiesOptions}
                      value={selectedCities}
                      onChange={setSelectedCities}
                    />
                  </div>
                </div>
              </Fieldset>
              <div style={{ marginBottom: 20 }}>
                <Btn onClick={() => localDispatch.onBtnExportarClick(state.entregasSelecionadas)}>
                  Exportar
                </Btn>
              </div>
              <CustomTabView
                activeIndex={state.activeIndex}
                onTabChange={localDispatch.onTabChange}
              >
                <TabPanel header="Listagem">
                  <TabListagem
                    entregas={locationFilteredEntregas}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                    onOpenModalDisponivel={localDispatch.openModalDisponivel}
                    entregasSelecionadas={state.entregasSelecionadas}
                    onSelectionChange={localDispatch.setEntregasSelecionadas}
                  />
                </TabPanel>
                <TabPanel header="Dashboards">
                  <TabDashboards
                    entregas={locationFilteredEntregas}
                    state={state}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                    localDispatch={localDispatch}
                  />
                </TabPanel>
              </CustomTabView>
            </>
          )}
        </CustomPanel>
      </div>
      <ModalDisponivel
        show={state.modalDisponivel.show}
        data={state.modalDisponivel.data}
        onClose={localDispatch.closeModalDisponivel}
        isBtnLoading={state.isBtnLoading}
        onSave={(delivery_id, available_to_transfer, reason) =>
          localDispatch.saveAvailableToTransfer(delivery_id, available_to_transfer, reason, selectedTp, state.periodo)
        }
      />
    </div>
  )
}

const TabListagem = ({
  entregas,
  globalFilter,
  setGlobalFilter,
  onOpenModalDisponivel,
  entregasSelecionadas,
  onSelectionChange,
}) => {
  return (
    <div style={{ marginTop: 16 }}>
      <DataTable
        paginator={true}
        rows={20}
        globalFilter={globalFilter}
        header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
        value={entregas}
        dataKey="delivery_step_id"
        selection={entregasSelecionadas}
        onSelectionChange={e => onSelectionChange(e.value)}
      >
        <Column selectionMode="multiple" style={{ width: '3em' }} />
        <Column
          field="created_at"
          header="Criada Em"
          style={tableCellCentered(100)}
          body={item => <DateTime>{item.created_at}</DateTime>}
        />
        <Column
          field="razao_social"
          header="Razão Social"
          body={entrega => (
            <>
              <div>{entrega.razao_social}</div>
              <small>
                <Cnpj>{entrega.cnpj}</Cnpj>
              </small>
            </>
          )}
        />
        <Column field="city" header="Cidade" body={item => `${item.city} - ${item.uf_sigla}`} />
        <Column field="identifier" header="Identificador" style={tableCellCentered(120)} />
        <Column field="company_name" header="Empresa" style={tableCellCentered(120)} />
        <Column field="tp_name" header="Destino" />
        <Column field="qte_sku" header="Qte. Volumes" style={tableCellCentered(110)} />
        <Column
          field="weightTotal"
          header="Peso Bruto"
          style={tableCellCentered(120)}
          body={i => <NumeroDecimal>{i.weightTotal}</NumeroDecimal>}
        />
        <Column
          field="available_to_transfer"
          header="Disponível"
          style={tableCellCentered(100)}
          body={entrega => {
            const isAvailable = entrega.available_to_transfer === 1 || entrega.available_to_transfer === true
            return (
              <span
                className={isAvailable ? 'badge-disponivel-sim' : 'badge-disponivel-nao'}
                style={{
                  backgroundColor: isAvailable ? '#14b0bf' : '#dc3545',
                  color: '#fff',
                  padding: '3px 10px',
                  borderRadius: 12,
                  cursor: 'pointer',
                  fontSize: '0.8rem',
                  whiteSpace: 'nowrap',
                }}
                onClick={() => onOpenModalDisponivel(entrega)}
              >
                {isAvailable ? 'Sim' : 'Não'}
              </span>
            )
          }}
        />
        <Column
          field="status"
          header="Status"
          style={tableCellCentered(100)}
          body={entrega => <BadgeStatusEntrega status={entrega.status} />}
        />
      </DataTable>
    </div>
  )
}

const TabDashboards = ({ entregas, state, globalFilter, setGlobalFilter, localDispatch }) => {
  let agrupadoPorDestino = {}
  let agrupadosPorUf = {}
  entregas.forEach(entrega => {
    const uf = entrega.uf
    if (!agrupadosPorUf[uf]) {
      agrupadosPorUf[uf] = {
        uf,
        qte_nfs: 0,
        qte_volumes: 0,
        qte_sku: 0,
        weightTotal: 0,
        color: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
      }
    }
    agrupadosPorUf[uf].qte_nfs += 1
    agrupadosPorUf[uf].qte_volumes += entrega.qte_volumes || 0
    agrupadosPorUf[uf].qte_sku += entrega.qte_sku || 0
    agrupadosPorUf[uf].weightTotal += entrega.weightTotal

    const tp = entrega.tp_name
    if (!agrupadoPorDestino[tp]) {
      agrupadoPorDestino[tp] = {
        tp,
        qte_nfs: 0,
        qte_volumes: 0,
        qte_sku: 0,
        weightTotal: 0,
        color: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
      }
    }
    agrupadoPorDestino[tp].qte_nfs += 1
    agrupadoPorDestino[tp].qte_volumes += entrega.qte_volumes || 0
    agrupadoPorDestino[tp].qte_sku += entrega.qte_sku || 0
    agrupadoPorDestino[tp].weightTotal += entrega.weightTotal
  })

  agrupadosPorUf = Object.values(agrupadosPorUf)
  agrupadoPorDestino = Object.values(agrupadoPorDestino)

  return (
    <div style={{ marginTop: 16 }} className="p-grid">
      <div className="p-col-8">
        <h3 className="text-center">Carga Parada Por Estado</h3>
        <DataTable
          paginator={true}
          rows={20}
          globalFilter={globalFilter}
          header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
          value={agrupadosPorUf}
          emptyMessage="Nenhum registro encontrado"
        >
          <Column field="uf" header="Estado" />
          <Column field="qte_nfs" header="Qte. NFs" style={tableCellCentered(90)} />
          <Column field="qte_volumes" header="Qte. Volumes" style={tableCellCentered(110)} />
          <Column
            field="weightTotal"
            header="Peso Bruto"
            style={tableCellCentered(120)}
            body={i => <NumeroDecimal>{i.weightTotal}</NumeroDecimal>}
          />
          <Column field="qte_sku" header="Qte. SKU´s" style={tableCellCentered(110)} />
          <Column
            header="Menu"
            style={tableCellCentered(70)}
            body={estado => (
              <ThreeDots
                items={MENU_ITEMS_NAMES}
                onClick={item => localDispatch.onMenuItemClicked(item, estado)}
              />
            )}
            bodyStyle={tableCellCentered()}
          />
        </DataTable>
      </div>
      {!!agrupadosPorUf.length && (
        <div className="p-col-4">
          <ResponsiveContainer height={270} width="100%">
            <PieChart>
              <Pie data={agrupadosPorUf} dataKey={'qte_sku'} nameKey="uf">
                {agrupadosPorUf.map(item => (
                  <Cell dataKey={item.qte_sku} key={item.uf} fill={item.color} />
                ))}
              </Pie>
              <Legend verticalAlign="bottom" layout="horizontal" align="center" />
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      )}

      <div className="p-col-8">
        <h3 className="text-center">Carga Parada Por Destino</h3>
        <DataTable
          paginator={true}
          rows={20}
          globalFilter={globalFilter}
          header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
          value={agrupadoPorDestino}
          emptyMessage="Nenhum registro encontrado"
        >
          <Column field="tp" header="Destino" />
          <Column field="qte_nfs" header="Qte. NFs" style={tableCellCentered(90)} />
          <Column field="qte_volumes" header="Qte. Volumes" style={tableCellCentered(110)} />
          <Column
            field="weightTotal"
            header="Peso Bruto"
            style={tableCellCentered(120)}
            body={i => <NumeroDecimal>{i.weightTotal}</NumeroDecimal>}
          />
          <Column field="qte_sku" header="Qte. SKU´s" style={tableCellCentered(110)} />
          <Column
            header="Menu"
            style={tableCellCentered(70)}
            body={destino => (
              <ThreeDots
                items={MENU_ITEMS_NAMES}
                onClick={item => localDispatch.onMenuItemClicked(item, destino)}
              />
            )}
            bodyStyle={tableCellCentered()}
          />
        </DataTable>
      </div>
      {!!agrupadoPorDestino.length && (
        <div className="p-col-4">
          <ResponsiveContainer height={270} width="100%">
            <PieChart>
              <Pie data={agrupadoPorDestino} dataKey={'qte_sku'} nameKey="tp">
                {agrupadoPorDestino.map(item => (
                  <Cell dataKey={item.qte_sku} key={item.tp} fill={item.color} />
                ))}
              </Pie>
              <Legend verticalAlign="bottom" layout="horizontal" align="center" />
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      )}

      <ModalDetalhesPorEmpresa
        show={state.modal.show}
        onModalClose={localDispatch.closeModal}
        data={state.modal.data}
        entregas={state.entregas}
      />
    </div>
  )
}
const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CargasParadasTransferencia))
